import * as React from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory, useLocation } from "react-router-dom"
import ReactGA from 'react-ga'
import './App.css';
import { Footer } from './Footer/Footer';
import {Header} from './Header/Header'
import {Menu} from './Menu/Menu'
import { EditTraining } from './Page/Admin/EditTraining';
import { UserAddTraining } from './Page/Admin/UserAddTraining';
import { Administration } from './Page/Administration';
import { BuySuccess } from './Page/BuySuccess';
import { BuyTraining } from './Page/BuyTraining';
import { Connexion } from './Page/Connexion';
import { ForgetPassword } from './Page/ForgetPassword';
import { Home } from './Page/Home';
import { NoMatch } from './Page/NoMatch';
import { RegenPassword } from './Page/RegenPassword';
import { Register } from './Page/Register';
import { TrainingDetail } from './Page/TrainingDetail';
import { UserDetail } from './Page/UserDetail';

let username = ""
let userId : number = 0
let userIsStaff = false
if (localStorage.getItem('username')) username = localStorage.getItem('username')!;
if (localStorage.getItem('userId')) userId = parseInt(localStorage.getItem('userId')!);
if (localStorage.getItem('userIsStaff') === 'true') userIsStaff = true;

export const UsernameContext = React.createContext<any>(username)
export const UserIdContext = React.createContext<any>(userId)
export const UserIsStaffContext = React.createContext<any>(userIsStaff)

const trackingID = "UA-107036690-1"
ReactGA.initialize(trackingID)
ReactGA.pageview(window.location.pathname + window.location.search)

export const App: React.FunctionComponent = (props) => {

  const[currentUsername, setCurrentUsername] = React.useState(username)
  const[currentUserId, setCurrentUserId] = React.useState(userId)
  const[currentUserIsStaff, setCurrentUserIsStaff] = React.useState(userIsStaff)

  const usePageViews = () => {
    let location = useLocation()
    React.useEffect(()=>{
      console.log("eformations" + location.pathname)
      ReactGA.pageview("eformations" + location.pathname)
    }, [location])
  }

  const isOutdated = () => {
    const now = Date.now()
    const deadline = new Date('2022-02-01').getTime()
    if(now >= deadline) {
      if(username){
        localStorage.clear()
        window.location.reload()
      }
      return true
    }
    else {
      return false
    }
  }

  const displayApp = () => {
    if(isOutdated()){
      return(
        <div className="Page">
          <h2>La plateforme de e-formation a changé !</h2>
          <p>Vous pourrez la retrouver en cliquant <a href="https://laurencebrun.podia.com/">ici</a></p>
          <p>Pour avoir accès aux formations déjà acquises sur l'ancienne plateforme, merci de me contacter <a href="https://en-deuil-et.com/index.php?contact">ici</a></p>
        </div>
      )
    }
    else {
      return(
        <div className="Page">
            <Switch>
              <Route path="/" component={Home} exact={true} />
              <Route path="/connexion" component={Connexion} exact={true} />
              <Route path="/register" component={Register} exact={true} />
              <Route path="/forgetPassword" component={ForgetPassword} exact={true} />
              <Route path="/password-reset/confirm/:uidb64/:token" component={RegenPassword} exact={true} />
              <Route path="/training/:id" component={TrainingDetail} exact={true} />
              <Route path="/training/:id/buy" component={BuyTraining} exact={true} />
              <Route path="/training/:id/buySuccess" component={BuySuccess} exaxt={true} />
              <Route path="/user/:username" component={UserDetail} exact = {true} />
              <Route path="/admin" component={Administration} exact={true} />
              <Route path="/admin/user/:id/addTraining" component={UserAddTraining} exact={true} />
              <Route path="/admin/editTraining/:id" component={EditTraining} exact = {true} />
              <Route path="*" component={NoMatch}/>
            </Switch>   
            </div>
      )
    }
  }

 

  return(
    <UsernameContext.Provider value={{currentUsername, setCurrentUsername}}>
      <UserIdContext.Provider value={{currentUserId, setCurrentUserId}}>
        <UserIsStaffContext.Provider value={{currentUserIsStaff, setCurrentUserIsStaff}}>
          {usePageViews()}
          <div className="App">
          <div className="AppFront">
            <div className="Header"><Header /></div>
            <div className="Menu"><Menu /></div>
            {displayApp()}
            <div className="Footer"><Footer /></div>       
          </div>
        </div>
        </UserIsStaffContext.Provider>
      </UserIdContext.Provider>
    </UsernameContext.Provider>
)
}
